import { withQuery } from './lib/withQuery'

export const getAuthorAudioUrl = () => 'audio/info'

export const getMyAudiosUrl = () => 'my/audio'

export const getCreateAudioFromUrlUrl = () => 'audio/url'

export const getAuthorAudiosUrl = () => 'author/audio'

export const getPaginatedAuthorAudiosUrl = () => 'author/audio'

export const getPaginatedUserAudiosUrl = () => 'my/audio'

export const getAudiosByIdsUrl = () => 'audio'

export const createAudioUrl = () => 'audio'

export const deleteAudioUrl = (id: string) => withQuery('audio', { id })

export const updateAudioUrl = (id: string) => withQuery('audio', { id })

export const assignAudioToUserUrl = (audioId: string) => withQuery('audio/assign', { id: audioId })

export const getDownloadFormatsUrl = (audioId: string) => withQuery('download', { id: audioId })

export const getAsyncProcessesUrl = () => 'processes'

export const getHasAudacityAudiosUrl = () => 'has-audacity-audios'

export const addWaitListUrl = () => 'wait/add'
